import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportOpenedDebits from '@/pages/report-opened-debits/ReportOpenedDebits'

export default {
  path: '/report-opened-debits',
  name: 'ReportOpenedDebits',
  components: {
    mainContent: ReportOpenedDebits,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-notify'
    },
    breadcrumb: {
      title: 'Relatório Veículos Devedores',
      paths: [
        { title: 'Relatórios' },
        { title: 'Veículos Devedores' }
      ]
    }
  }
}